module.exports = __webpack_public_path__ + "img/off_tackle_right.ac52dad2.jpg";